import React from "react";
import t from "i18n";

const LanguagesFilter = ({ languages, updateLanguages }) => {
  return (
    <ul className={"flex"}>
      <li
        className={"event-registrant-language-option " + (languages.includes('FR') ? 'selected' : '')}
        onClick={() => updateLanguages('FR')}
      >
        <span>{t('FR')}</span>
      </li>
      <li
        className={"event-registrant-language-option " + (languages.includes('NL') ? 'selected' : '')}
        onClick={() => updateLanguages('NL')}
      >
        <span>{t('NL')}</span>
      </li>
      <li
        className={"event-registrant-language-option " + (languages.includes('EN') ? 'selected' : '')}
        onClick={() => updateLanguages('EN')}
      >
        <span>{t('EN')}</span>
      </li>
    </ul>
  );
};

export default LanguagesFilter;



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/EventRegistrantLinechart/LanguagesFilter.js